import { Controller } from "../../Controller";
import {
    AtualizarConfigEnvelopeService,
    CriarConfigEnvelopeService,
    DeletarConfigEnvelopeService,
    GetConfigEnvelopeService,
    ListarConfigEnvelopeService,
} from "../../../Services/Geral/ConfigEnvelope/ConfigEnvelopeServices";
import {
    IConfigEnvelope,
    ICriarConfigEnvelope,
} from "../../../Interfaces/Geral/ConfigEnvelope/ConfigEnvelopeInterfaces";

export async function ListarConfigEnvelopeController(idProuto: number) {
    return Controller(ListarConfigEnvelopeService(idProuto));
}

export async function GetConfigEnvelopeController(idConfigEnvelope: number) {
    return Controller(GetConfigEnvelopeService(idConfigEnvelope));
}

export async function CriarConfigEnvelopeController(
    configEnvelope: ICriarConfigEnvelope
) {
    return Controller(CriarConfigEnvelopeService(configEnvelope));
}

export async function DeletarConfigEnvelopeController(
    idConfigEnvelope: number
) {
    return Controller(DeletarConfigEnvelopeService(idConfigEnvelope));
}

export async function AtualizarConfigEnvelopeController(
    configEnvelope: IConfigEnvelope
) {
    return Controller(AtualizarConfigEnvelopeService(configEnvelope));
}
